import React, {useState, useEffect, useContext} from 'react'
import {Link} from 'react-router-dom'

import withApiService from '../hoc/with-api-service'
import withData from '../hoc/with-data'
import withCategory from '../hoc/with-category'
import {ApiServiceContext, BasketContext} from '../context'

import FavoriteHeart from '../favorite-heart'
import ProductCardSlider from './product-card-slider'
import Counter from '../counter'

const ProductCard = ({response, params: id, categoryTitle, setCategoryId, setCategoryTitle, setTitle, setFilters}) => {
  const {data} = response;

  const apiService = useContext(ApiServiceContext);
  const {cartId, setCartId, setBasket} = useContext(BasketContext);

  const [currentImage, setCurrentImage] = useState(0);
  const [available, setAvailable] = useState(false);
  const [activeSize, setActiveSize] = useState(null);
  const [amount, setAmount] = useState(1);
  const [inBasketText, setInBasketText] = useState('В корзину');

  const sizes = data && data.sizes
    .filter((item, index, arr) =>
      index === arr.findIndex(({size, available}) => (
        size === item.size && available === item.available
      ))
    )
    .map(({size, available}) => (
      <li className={size === parseInt(activeSize) ? "active" : ""}
          key={size}>
        <a data-available={available} href="/">{size}</a>
      </li>
    ));

  const inBasketDisabledClassName = activeSize && available ? '' : 'in-basket_disabled';

  let images = [];
  if (data) {
    images = data.images;
  }

  useEffect(() => {
    if (data) {
      setFilters({
        type: data.type,
        color: data.color
      });
      setTitle(data.title);
      setCategoryId(data.categoryId)
    }
  }, [data]);

  useEffect(() => {
    setCategoryTitle(categoryTitle)
  }, [categoryTitle]);

  const handleSizeClick = event => {
    event.preventDefault();
    const {target} = event;
    const {available} = target.dataset;

    if (target.tagName.toLowerCase() !== 'a') {
      return
    }

    if (activeSize) {
      setAmount(1)
    }

    if (available === 'true') {
      setAvailable(true);
      setInBasketText('В корзину');
    } else {
      setAvailable(false);
    }

    setActiveSize(target.text);
  };

  const handleImageSliderClick = event => {
    event.preventDefault();

    setCurrentImage(parseInt(event.target.dataset.id))
  };

  const handleInBasketClick = event => {
    event.preventDefault();
    if (!activeSize || !available) {
      setInBasketText('Выберите размер!');
      return
    }

    const purchasing = {
      "id": parseInt(id),
      "size": parseInt(activeSize),
      "amount": parseInt(amount)
    };

    if (!cartId) {
      apiService.setCart('', purchasing)
        .then(({data}) => {
          const {id} = data;
          if (id) {
            setCartId(id);
            setBasket([purchasing])
          }
        })
        .catch(console.error)
    } else {
      apiService.setCart(`${cartId}`, purchasing)
        .then(({data}) => {
          const {products} = data;
          setBasket(products)
        })
        .catch(console.error)
    }
  };

  return (
    <main className="product-card">
      <section className="product-card-content">
        <h2 className="section-name">{data && data.type}</h2>
        <section className="product-card-content__main-screen">
          {images.length > 1 && (
            <section className="main-screen__favourite-product-slider"
                     onClick={handleImageSliderClick}>
              <ProductCardSlider sliderData={data} id={data && data.id}/>
            </section>
          )}
          <div className="main-screen__favourite-product-pic">
            <img src={images[currentImage]} alt={data && data.title}/>
          </div>
          <div className="main-screen__product-info">
            <div className="product-info-title"><h2>{data && data.title}</h2>
              {available && (<div className="in-stock">В наличии</div>)}
            </div>
            <div className="product-features">
              <table className="features-table">
                <tbody>
                <tr>
                  <td className="left-col">Артикул:</td>
                  <td className="right-col">{data && data.sku}</td>
                </tr>
                <tr>
                  <td className="left-col">Производитель:</td>
                  <td className="right-col">
                    <Link to={{
                      pathname: `/catalogue`,
                      state: {
                        filter: {
                          filterName: 'brandFilter',
                          value: data && data.brand
                        }
                      }
                    }}>
                      <span className="producer">{data && data.brand}</span>
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="left-col">Цвет:</td>
                  <td className="right-col">{data && data.color}</td>
                </tr>
                <tr>
                  <td className="left-col">Материалы:</td>
                  <td className="right-col">{data && data.material}</td>
                </tr>
                <tr>
                  <td className="left-col">Сезон:</td>
                  <td className="right-col">{data && data.season}</td>
                </tr>
                <tr>
                  <td className="left-col">Повод:</td>
                  <td className="right-col">{data && data.reason}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <p className="size">Размер</p>
            <ul className="sizes"
                onClick={handleSizeClick}>
              {sizes}
            </ul>
            <div className="size-wrapper">
              <span className="size-rule"/><p className="size-table">Таблица размеров</p>
            </div>
            <FavoriteHeart id={parseInt(id)}>
              {(handleClick, classNameEnd, inFavourites) =>
                (<a href="/" className="in-favourites-wrapper" onClick={handleClick}>
                  <div className={`favourite${classNameEnd}`}/>
                  <p className="in-favourites">{inFavourites}</p>
                </a>)
              }
            </FavoriteHeart>
            <Counter count={amount}
                     setCount={setAmount}/>
            <div className="price">{data && data.price.toLocaleString('ru-RU')} ₽</div>
            <button className={`in-basket in-basket-click ${inBasketDisabledClassName}`}
                    onClick={handleInBasketClick}>
              {inBasketText}</button>
          </div>
        </section>
      </section>
    </main>
  )
};

const mapMethodsToProps = (apiService) => {
  return {
    getData: apiService.getProduct
  };
};

export default withApiService(mapMethodsToProps)(withData(withCategory(ProductCard)))
